import { ref } from '@vue/composition-api'
import formatDate from '@/utils/date-format'

export default function useBatchList(ctx) {
  const columns = [
    {
      key: 'batchNumber',
      label: 'Batch Number',
    },
    {
      key: 'createdAt',
      label: 'Created At',
      formatter: val => formatDate(val),
    },
    {
      key: 'batchState',
      label: 'Batch State',
    },
    {
      key: 'details',
      label: 'Details',
    },
    'actions',
  ]

  const batchLoading = ref(false)
  const cardsBatch = ref([])

  const fetchCardsBatch = async () => {
    try {
      batchLoading.value = true
      const res = await ctx.root.$store.dispatch('cardsBatch/fetchCardsBatch')
      cardsBatch.value = res.data.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    } finally {
      batchLoading.value = false
    }
  }

  const downloadBatch = async batchId => {
    const res = await ctx.root.$store.dispatch('cardsBatch/downloadBatch', batchId)
    const { url } = res.data.data
    window.open(url)
  }

  fetchCardsBatch()

  return {
    batchLoading,
    columns,
    cardsBatch,
    downloadBatch,
  }
}
